import { Grid, Paper, useTheme } from "@mui/material";
import styled from "@emotion/styled";

import { tokens } from "../../../theme";
import {
  convertMessageToHtml,
  getCodeTableDescriptionByCodeTableUid,
  getLookupDescriptionByCode,
} from "../../../utilities/helpers";
import { MESSAGE_STYLES } from "../../../utilities/constants";

const CoverageReport = ({
  inspection,
  inspectionDetails,
  codeTables,
  lookups,
  systemChoiceUid,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const ItemHeader = styled(Paper)(({ theme }) => ({
    backgroundColor: colors.blueAccent[100],
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "left",
  }));

  const ItemDetail = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "left",
  }));

  // filter quality_protocol by system choice
  const foundProtocolQualities = inspectionDetails?.filter(
    (inspectionDetail) =>
      inspectionDetail?.detail?.systemChoice === systemChoiceUid
  );

  return (
    <>
      {foundProtocolQualities &&
        foundProtocolQualities.map((foundProtocolQuality) => (
          <Grid container key={foundProtocolQuality.code} spacing={1}>
            <Grid item xs={12} style={{marginTop:'0.5em'}}>
              <ItemHeader>
                {getLookupDescriptionByCode(
                  lookups,
                  foundProtocolQuality?.code
                )}
              </ItemHeader>
            </Grid>
            <Grid item xs={12} style={{marginLeft:'0.5em'}}>
              <ItemDetail>
                {getCodeTableDescriptionByCodeTableUid(
                  codeTables,
                  foundProtocolQuality?.detail?.coverageChoice
                )}
              </ItemDetail>
            </Grid>
            {foundProtocolQuality?.detail?.coverageComment && (
              <Grid item xs={12} style={{marginLeft:'1em'}}>
                <ItemDetail>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: convertMessageToHtml(foundProtocolQuality?.detail?.coverageComment),
                    }}
                    style={{
                      lineHeight: "1.5",
                      "& pre": MESSAGE_STYLES.pre,
                      "& code": MESSAGE_STYLES.code,
                      "& strong": MESSAGE_STYLES.strong,
                      "& em": MESSAGE_STYLES.em,
                    }}
                  />
                </ItemDetail>
              </Grid>
            )}
          </Grid>
        ))}
    </>
  );
};

export default CoverageReport;
